export default function Products() {
  return (
    <div className="relative py-40 bg-gray-50">
      <div className="max-w-[1400px] mx-auto px-8">
        {/* Section header */}
        <div className="mb-20">
          <div className="text-xs uppercase tracking-[4px] text-gray-500 mb-4">OUR PRODUCTS</div>
          <h2 className="text-[96px] font-bold text-gray-900 ml-32">VPN & CLEANER</h2>
        </div>

        {/* Products grid */}
        <div className="relative" data-product-shop>
          {/* VPN Card - Left Top */}
          <div className="absolute left-0 top-20 w-[45%] h-[520px] bg-gradient-to-br from-gray-900 to-gray-800 rounded-3xl p-12 flex flex-col items-center justify-center shadow-2xl" style={{ boxShadow: '0 0 60px rgba(20, 184, 166, 0.15)' }}>
            <div className="w-36 h-36 bg-gradient-to-br from-teal-400 to-teal-600 rounded-full flex items-center justify-center mb-8 shadow-lg">
              <i className="ri-shield-check-line text-7xl text-white"></i>
            </div>
            <h3 className="text-5xl font-bold text-white mb-8">VPN</h3>
            <div className="space-y-4 text-center">
              <div className="flex items-center justify-center gap-3">
                <i className="ri-check-line text-xl text-teal-400"></i>
                <p className="text-base text-white/70">Secure Connection</p>
              </div>
              <div className="flex items-center justify-center gap-3">
                <i className="ri-check-line text-xl text-teal-400"></i>
                <p className="text-base text-white/70">Global Servers</p>
              </div>
              <div className="flex items-center justify-center gap-3">
                <i className="ri-check-line text-xl text-teal-400"></i>
                <p className="text-base text-white/70">Privacy Protection</p>
              </div>
            </div>
          </div>

          {/* Cleaner Card - Right Center */}
          <div className="absolute right-0 top-0 w-[48%] h-[480px] bg-white rounded-3xl p-12 flex flex-col items-center justify-center shadow-xl border-2 border-transparent" style={{ backgroundImage: 'linear-gradient(white, white), linear-gradient(135deg, #14B8A6, #10B981)', backgroundOrigin: 'border-box', backgroundClip: 'padding-box, border-box' }}>
            {/* Progress indicator */}
            <div className="relative w-44 h-44 mb-8">
              <svg className="w-full h-full transform -rotate-90">
                <circle
                  cx="88"
                  cy="88"
                  r="80"
                  stroke="#E5E7EB"
                  strokeWidth="8"
                  fill="none"
                />
                <circle
                  cx="88"
                  cy="88"
                  r="80"
                  stroke="url(#gradient)"
                  strokeWidth="8"
                  fill="none"
                  strokeDasharray="502.4"
                  strokeDashoffset="50.24"
                  strokeLinecap="round"
                />
                <defs>
                  <linearGradient id="gradient" x1="0%" y1="0%" x2="100%" y2="100%">
                    <stop offset="0%" stopColor="#14B8A6" />
                    <stop offset="100%" stopColor="#10B981" />
                  </linearGradient>
                </defs>
              </svg>
              <div className="absolute inset-0 flex flex-col items-center justify-center">
                <div className="text-4xl font-bold text-gray-900">95%</div>
                <div className="text-sm text-gray-600">Optimization</div>
              </div>
            </div>
            <h3 className="text-5xl font-bold text-gray-900 mb-8">CLEANER</h3>
            <div className="space-y-4 text-center">
              <div className="flex items-center justify-center gap-3">
                <i className="ri-check-line text-xl text-teal-600"></i>
                <p className="text-base text-gray-700">Storage Optimization</p>
              </div>
              <div className="flex items-center justify-center gap-3">
                <i className="ri-check-line text-xl text-teal-600"></i>
                <p className="text-base text-gray-700">Cache Management</p>
              </div>
              <div className="flex items-center justify-center gap-3">
                <i className="ri-check-line text-xl text-teal-600"></i>
                <p className="text-base text-gray-700">Performance Boost</p>
              </div>
            </div>
          </div>

          {/* Feature Highlight Card - Bottom Center */}
          <div className="absolute left-1/2 transform -translate-x-1/2 bottom-0 w-[60%] h-[200px] bg-gradient-to-r from-white to-teal-50 rounded-2xl flex items-center justify-center p-8 shadow-inner">
            <p className="text-2xl text-center text-gray-800 italic" style={{ fontFamily: 'Georgia, serif' }}>
              Designed to enhance user experience and improve mobile device security
            </p>
          </div>
        </div>

        {/* Spacer for absolute positioning */}
        <div className="h-[720px]"></div>
      </div>
    </div>
  );
}
